import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const daysOfWeek = [
  'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
];

const VendorSignupConfirmation = () => {
  const [services, setServices] = useState([]);
  const [serviceDetails, setServiceDetails] = useState({});
  const [selectedDetails, setSelectedDetails] = useState({});
  const [availability, setAvailability] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    // Retrieve selections from localStorage
    const storedDetails = localStorage.getItem('selectedDetails');
    const storedAvailability = localStorage.getItem('availability');
    setSelectedDetails(storedDetails ? JSON.parse(storedDetails) : {});
    setAvailability(storedAvailability ? JSON.parse(storedAvailability) : {});

    // Fetch all services
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/services`)
      .then(res => res.json())
      .then(data => setServices(data));

    // Fetch all service details
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/service_details/all`)
      .then(res => res.json())
      .then(data => {
        const detailsByService = {};
        data.forEach(detail => {
          if (!detailsByService[detail.service_id]) detailsByService[detail.service_id] = [];
          detailsByService[detail.service_id].push(detail);
        });
        setServiceDetails(detailsByService);
      });
  }, []);

  const handleSubmit = async () => {
    // Get vendorId from logged in user in localStorage
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const vendorId = user.id;
    try {
  await axios.post(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/vendor_schedule`, {
        vendorId,
        selections: availability,
      });
      // Remove local storage for availability and selectedDetails
      localStorage.removeItem('availability');
      localStorage.removeItem('selectedDetails');
      navigate('/vendorsignupverification');
    } catch (err) {
      alert('Failed to save schedule. Please try again.');
    }
  };

  return (
    <div style={styles.container}>
      <button
        style={styles.backButton}
        onClick={() => navigate('/vendorsignupnext')}
      >
        ← Back
      </button>
      <h2 style={styles.title}>Confirmation: Your Selected Service Details & Pickup Time Slots</h2>
      <div style={styles.servicesSection}>
        {services.map(service => (
          selectedDetails[service.id] && selectedDetails[service.id].length > 0 && (
            <div key={service.id} style={styles.serviceCard}>
              <h4 style={styles.serviceName}>{service.name}</h4>
              <p style={styles.serviceDesc}>{service.description}</p>
              <div style={styles.detailsGrid}>
                {serviceDetails[service.id] &&
                  serviceDetails[service.id]
                    .filter(detail => selectedDetails[service.id].includes(detail.id))
                    .map(detail => (
                      <div key={detail.id} style={styles.detailCard}>
                        <span style={{ fontWeight: 'bold', color: '#4078c0', fontSize: '1.08rem' }}>
                          {detail.name}
                        </span>
                        <p style={{ margin: '8px 0 0 0', color: '#555', fontSize: '0.98rem' }}>
                          {detail.description}
                        </p>
                        {detail.image_url && (
                          <img
                            src={detail.image_url}
                            alt={detail.name}
                            style={{
                              width: '100%',
                              maxHeight: '120px',
                              objectFit: 'cover',
                              borderRadius: '6px',
                              marginTop: '10px',
                              boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
                            }}
                          />
                        )}
                        <div style={{ marginTop: '14px' }}>
                          <h5 style={{ color: '#4078c0', fontSize: '1rem', marginBottom: '8px' }}>Pickup Time Slots</h5>
                          <table style={styles.table}>
                            <thead>
                              <tr>
                                <th style={styles.th}>Day</th>
                                <th style={styles.th}>Start Time</th>
                                <th style={styles.th}>End Time</th>
                              </tr>
                            </thead>
                            <tbody>
                              {daysOfWeek.map(day => (
                                <tr key={day}>
                                  <td style={styles.td}>{day}</td>
                                  <td style={styles.td}>{availability[detail.id]?.[day]?.start || '-'}</td>
                                  <td style={styles.td}>{availability[detail.id]?.[day]?.end || '-'}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ))}
              </div>
            </div>
          )
        ))}
      </div>
      <button
        style={styles.submitButton}
        onClick={handleSubmit}
      >
        Submit & Continue to Verification
      </button>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '40px auto',
    padding: '24px',
    background: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  title: {
    marginBottom: '16px',
    color: '#4078c0',
    fontSize: '1.5rem',
    textAlign: 'center',
  },
  servicesSection: {
    marginTop: '40px',
  },
  serviceCard: {
    background: '#f5f6fa',
    borderRadius: '8px',
    padding: '18px',
    marginBottom: '24px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
  },
  serviceName: {
    color: '#4078c0',
    fontWeight: 'bold',
    fontSize: '1.15rem',
    marginBottom: '8px',
  },
  serviceDesc: {
    color: '#555',
    marginBottom: '8px',
  },
  detailsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '18px',
    marginTop: '12px',
  },
  detailCard: {
    background: '#fff',
    borderRadius: '8px',
    padding: '14px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
    marginBottom: '0',
    minHeight: '120px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '10px',
  },
  th: {
    background: '#eaf1fb',
    color: '#4078c0',
    fontWeight: 'bold',
    padding: '6px',
    border: '1px solid #dbe6f6',
    textAlign: 'center',
    fontSize: '0.98rem',
  },
  td: {
    padding: '6px',
    border: '1px solid #dbe6f6',
    textAlign: 'center',
    fontSize: '0.98rem',
  },
  backButton: {
    marginBottom: '18px',
    padding: '8px 18px',
    borderRadius: '6px',
    background: '#eaf1fb',
    color: '#4078c0',
    fontWeight: 'bold',
    border: 'none',
    cursor: 'pointer',
    fontSize: '1rem',
  },
  submitButton: {
    marginTop: '24px',
    padding: '10px 18px',
    borderRadius: '6px',
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    cursor: 'pointer',
    fontSize: '1rem',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
};

export default VendorSignupConfirmation;